export default __webpack_public_path__ + "static/reg-step-eb4caee7f7eb94af75722502b43c6f22.png";